import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_GlobalConstants} from '../../../services/globalConstants.service';
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {Observable} from "rxjs/Observable";

declare let jQuery:any;
declare let $ :any;

declare let globalConstants;
declare let defaultGridViewSettings;

@Component({
  selector: 'openfx',
  templateUrl: './openfx.component.html',
  styleUrls: ['./openfx.component.css'],
})

export class OpenFXBranch implements OnInit, OnDestroy {

  private subscription: any;
  private globalConstants: any;
  private liquidityProviders: any;

  constructor (private titleService: Title, private constants: _GlobalConstants, private referenceData: _ReferenceDataService) {

  }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Open FX Orders");

    this.subscription = Observable.forkJoin(this.constants.getGlobalConstants(),
      this.referenceData.getLiquidityProviders()).subscribe((res:Array<any>) => {
      this.globalConstants = res[0];
      this.liquidityProviders = res[1];
      this.ready();
    });
  }
  ready() {

      $("#cancelAll").click(function() {
          $.ajax({
              url: "/ajax/fx-orders",
              type: "DELETE",
              success: function(data, textStatus, jqXHR ) {
                  if (jqXHR.status==200) {
                      $('#jqxGrid').jqxGrid('source').dataBind();
                  }
              },
          });
      });

      let source = {
          datatype : 'json',
          datafields : [{
              name : 'updateTimestamp',
              type : 'date',
              format: 'yyyy-MM-dd HH:mm:ss.fff'
          }, {
              name : 'orderState',
              type : 'string'
          }, {
              name : 'orderStateDisplayName',
              type : 'string',
              value: 'orderState',
              values: {
                  source: this.constants.getTranslatedValues('resources.orderUpdate.state'),
                  value: 'value',
                  name: 'display'
              }
          }, {
              name : 'externalOrderId',
              type : 'string'
          }, {
              name : 'currencyPair',
              type : 'string'
          }, {
              name : 'currency',
              type : 'string'
          }, {
            name : 'liquidityProviderId',
            type : 'string'
          }, {
            name : 'liquidityProviderDisplay',
            type : 'string',
            value: 'liquidityProviderId',
            values: {
              source: this.liquidityProviders,
              value: 'liquidityProviderId',
              name: 'displayName'
            }
          }, {
              name : 'contractType',
              type : 'string'
          }, {
              name : 'contractTypeDisplayName',
              type : 'string',
              value: 'contractType',
              values: {
                  source: this.constants.getTranslatedValues('resources.fxInstrument.type'),
                  value: 'value',
                  name: 'display'
              }
          }, {
              name : 'positionAction',
              type : 'string'
          }, {
              name : 'sideDisplayName',
              type : 'string',
              value: 'positionAction',
              values: {
                  source: this.constants.getTranslatedValues('resources.order.side'),
                  value: 'value',
                  name: 'display'
              }
          }, {
              name : 'orderQuantity',
              type : 'string'
          }, {
              name : 'valueDate',
              type : 'date',
              format : 'yyyy-MM-dd'
          }],
          id : 'internalOrderId',
          url : '/ajax/fx-orders',
          type : 'GET',
          async : true
      };

      let settings = defaultGridViewSettings("#jqxGrid", source);

      settings.columns = [{
          text : 'Last Updated',
          columntype : 'datetimeinput',
          datafield : 'updateTimestamp',
          cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
          width : '160'
      }, {
          text : 'Order State',
          columntype : 'textbox',
          datafield : 'orderStateDisplayName',
          width : '120'
      }, {
          text : 'External Order ID',
          columntype : 'textbox',
          datafield : 'externalOrderID',
          width : '130'
      }, {
          text : 'Ccy Pair',
          columntype : 'textbox',
          datafield : 'currencyPair',
          width : '100'
      }, {
          text : 'Ccy',
          columntype : 'textbox',
          datafield : 'currency',
          width : '80'
      }, {
          text : 'Broker',
          columntype : 'textbox',
          datafield : 'liquidityProviderDisplay',
          width : '80'
      }, {
          text : 'Contract Type',
          columntype : 'textbox',
          datafield : 'contractTypeDisplayName',
          width : '120'
      }, {
          text : 'Side',
          columntype : 'textbox',
          datafield : 'sideDisplayName',
          width : '80'
      }, {
          text : 'Quantity',
          columntype : 'textbox',
          datafield : 'orderQuantity',
          width : '90'
      }, {
          text : 'Value Date',
          columntype : 'datetimeinput',
          datafield : 'valueDate',
          cellsformat : 'yyyy-MMM-dd',
          width : '90'
      }];

      $("#jqxGrid").jqxGrid(settings);

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/orders/openfx/openfx.component.ts